import { useState, useEffect } from 'react';
import { locationService } from '../services/api';
import { analytics } from '../services/analytics';
import './LocationsPage.css';

const LocationsPage = () => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterType, setFilterType] = useState('all');

  useEffect(() => {
    analytics.trackPageView('locations_page');
    loadLocations();
  }, []);

  const loadLocations = async () => {
    try {
      setLoading(true);
      const response = await locationService.getAll();
      setLocations(response.data.data || []);
    } catch (error) {
      console.error('Error loading locations:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredLocations = locations.filter(location => {
    if (filterType === 'all') return location.active !== false;
    return location.type === filterType && location.active !== false;
  });

  const getLocationIcon = (type) => {
    return type === 'airport' ? '✈️' : '🏢';
  };

  const getLocationImage = (location) => {
    // Usar imagen específica de la ubicación o placeholder por tipo
    if (location.image) {
      return location.image;
    }
    const placeholders = {
      airport: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=400&h=300&fit=crop',
      office: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop'
    };
    return placeholders[location.type] || placeholders.office;
  };

  if (loading) {
    return (
      <div className="locations-page">
        <div className="locations-container">
          <div className="loading">Cargando ubicaciones...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="locations-page">
      <div className="locations-container">
        <div className="locations-header">
          <h1>Nuestras Ubicaciones</h1>
          <p className="locations-subtitle">Encuentra la sucursal más cercana para retirar y devolver tu vehículo</p>
        </div>

        <div className="locations-filters">
          <button 
            className={`filter-btn ${filterType === 'all' ? 'active' : ''}`}
            onClick={() => setFilterType('all')}
          >
            Todas las ubicaciones
          </button>
          <button 
            className={`filter-btn ${filterType === 'airport' ? 'active' : ''}`}
            onClick={() => setFilterType('airport')}
          >
            ✈️ Aeropuertos
          </button>
          <button 
            className={`filter-btn ${filterType === 'office' ? 'active' : ''}`}
            onClick={() => setFilterType('office')}
          >
            🏢 Oficinas
          </button>
        </div>

        <div className="locations-grid">
          {filteredLocations.map(location => (
            <div key={location.id} className="location-card">
              <div className="location-image">
                <img src={getLocationImage(location)} alt={location.name} />
                <div className="location-type-badge">
                  {getLocationIcon(location.type)} {location.type === 'airport' ? 'Aeropuerto' : 'Oficina'}
                </div>
              </div>
              
              <div className="location-content">
                <h3 className="location-name">{location.name}</h3>
                <div className="location-details">
                  <div className="location-detail">
                    <span className="detail-icon">📍</span>
                    <span>{location.address || location.city}</span>
                  </div>
                  {location.city && (
                    <div className="location-detail">
                      <span className="detail-icon">🏙️</span>
                      <span>{location.city}</span>
                    </div>
                  )}
                </div>
                
                <div className="location-actions">
                  <button className="btn-directions">
                    🗺️ Cómo llegar
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredLocations.length === 0 && (
          <div className="locations-empty">
            <p>No hay ubicaciones disponibles con el filtro seleccionado.</p>
            <button 
              className="btn-reset"
              onClick={() => setFilterType('all')}
            >
              Ver todas
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationsPage;
